export default __webpack_public_path__ + "240379ecf35e7370776aba0948ba537a.png";